import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

/** Shared "edit ticket" dialog — creator/admin only (enforced server-side). */
export function TicketEditDialog({ open, onOpenChange, ticket, onSave, saving = false }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  useEffect(() => {
    if (open) { setTitle(ticket?.title || ""); setDescription(ticket?.description || ""); }
  }, [open, ticket]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="ticket-edit-dialog">
        <DialogHeader>
          <DialogTitle>Edit ticket</DialogTitle>
          <DialogDescription>Update the title or details. The conversation and photos stay as they are.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Title *</Label>
            <Input value={title} onChange={(e) => setTitle(e.target.value)} maxLength={120} className="rounded-sm h-10" data-testid="ticket-edit-title" />
          </div>
          <div>
            <Label>Details</Label>
            <Textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={4} className="rounded-sm" data-testid="ticket-edit-description" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-sm" onClick={() => onOpenChange(false)} data-testid="ticket-edit-cancel">Cancel</Button>
          <Button className="rounded-sm" disabled={saving || !title.trim()} onClick={() => onSave({ title: title.trim(), description: description.trim() })} data-testid="ticket-edit-save">
            {saving ? "Saving…" : "Save changes"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
